import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaObservationByInspect} from '../../../../../../../../util/validationLavanderia'
import {ObservationModel, SelectModel} from '../../../../../../model'
import {createObservation, updateObservation} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../../../components/UI/Select'
import {InputText, InputDateForm} from '../../../../../../../../components/UI/Input'
import {getMasterService} from '../../../../../../../central/services'
import {formatDate} from '../../../../../../../../util/dates'
import {ShowSnackBar} from '../../../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getObservationList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailObservation?: ObservationModel
}

const ModalAddObservation: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getObservationList,
  detailObservation,
  idPermission,
}) => {
  const {currentTabItem} = useLavanderia()
  const methods = useForm<ObservationModel>({
    resolver: yupResolver(schemaObservationByInspect),
  })

  const {
    control,
    setValue,
    handleSubmit,
    reset,
    register,
    formState: {errors},
  } = methods
  const [typeInspect, setTypeInspect] = useState<SelectModel[]>([])
  const [maxValueDate, setMaxValueDate] = useState<string>('')
  const getTypeReceptionList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'CategoriaObservacionLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))

      setTypeInspect(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    if (idPermission) {
      const {
        categoria,
        codigoObservacion,
        descripcionObservacion,
        fechaDeteccion,
        fechaPlanificadaCierre,
        fechaCierre,
      } = detailObservation as any
      setValue('id', idPermission)
      setValue('categoria', categoria)
      setValue('codigoObservacion', codigoObservacion)
      setValue('descripcionObservacion', descripcionObservacion)
      setValue('fechaDeteccion', formatDate(fechaDeteccion))
      setValue('fechaPlanificadaCierre', formatDate(fechaPlanificadaCierre))
      setValue('fechaCierre', formatDate(fechaCierre))
    }
  }, [idPermission])

  useEffect(() => {
    getTypeReceptionList()
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
  }

  const onSubmit = async (data: ObservationModel) => {
    try {
      if (idPermission) {
        let obj = {
          mantenimientoInspeccionId: currentTabItem.idToEdit,
          detalle: data,
        }
        const {data: res} = await updateObservation(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getObservationList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      } else {
        let obj = {
          mantenimientoInspeccionId: currentTabItem.idToEdit,
          detalle: data,
        }
        const {data: res} = await createObservation(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getObservationList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      }
    } catch (error) {}
  }

  const handleGetMaxValueDate = (e: any) => {
    const value = e.target.value
    setMaxValueDate(value)
  }
  let isDisabled = idPermission ? true : false
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {<h5 className='modal-title'>Agregar Observación</h5>}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Categoría:</label>
                  <Select control={control} name='categoria' data={typeInspect} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Código de Observación:</label>
                  <InputText
                    name='codigoObservacion'
                    textPlaceholder='Escribe la nomenclatura'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                    disabled={isDisabled}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Descripción de Observación:</label>
                  <InputText
                    name='descripcionObservacion'
                    textPlaceholder='Escribe la nomenclatura'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Fecha de detección:</label>
                  <InputDateForm
                    name='fechaDeteccion'
                    register={register}
                    errors={errors}
                    customOnChangeFunction={handleGetMaxValueDate}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Fecha planificada de cierre:</label>
                  <InputDateForm
                    name='fechaPlanificadaCierre'
                    register={register}
                    errors={errors}
                    minValue={maxValueDate}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label>Fecha de cierre:</label>
                  <InputDateForm
                    name='fechaCierre'
                    register={register}
                    errors={errors}
                    minValue={maxValueDate}
                  />
                </div>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddObservation}
